export default __webpack_public_path__ + "static/armony-plus-2-b4097697724fe03d76b8bc4b2d990b2f.jpg";